import type { OrderPlatform } from "../../api/types";
import { MyMenuLogo } from "./MyMenuLogo";
import { TakeawayLogo } from "./TakeawayLogo";

/**
 * Uber Eats next to its orders in the list (its bridge, Furkan 17/10/2026): its name in two words, all in its green
 * ("Eats" bold), as wide as the logos of Mymenu.be and Takeaway. Plain text, not Uber's drawn logo.
 */
export function UberEatsLogo() {
  return (
    <span className="ubereats-logo" role="img" aria-label="Uber Eats">
      <span aria-hidden="true">Uber</span> <b aria-hidden="true">Eats</b>
    </span>
  );
}

/** The mark of the platform an online order came from, next to it in the list of orders. */
export function PlatformLogo({ platform }: { platform: OrderPlatform }) {
  switch (platform) {
    case "mymenu":
      // in red (Furkan, 15/10/2026)
      return <MyMenuLogo />;
    case "takeaway":
      return <TakeawayLogo />;
    case "ubereats":
      return <UberEatsLogo />;
  }
}
